import dialogPolyfill from 'dialog-polyfill'

// Ensures dialog elements are polyfilled.
export function loadDialogs () {
  const elems = document.querySelectorAll('dialog')
  const dialogs = []

  for (const element of elems) {
    dialogPolyfill.registerDialog(element)
  }

  return dialogs
}
